__turbopack_context__.v({
  "card": "index-module-scss-module__8yzwdq__card",
  "card-landscape-on-desktop": "index-module-scss-module__8yzwdq__card-landscape-on-desktop",
  "card-landscape-on-msite": "index-module-scss-module__8yzwdq__card-landscape-on-msite",
  "card-mini-on-desktop": "index-module-scss-module__8yzwdq__card-mini-on-desktop",
  "card-mini-on-msite": "index-module-scss-module__8yzwdq__card-mini-on-msite",
  "price": "index-module-scss-module__8yzwdq__price",
  "seller": "index-module-scss-module__8yzwdq__seller",
  "subject": "index-module-scss-module__8yzwdq__subject",
  "thumbnail": "index-module-scss-module__8yzwdq__thumbnail",
});
